import React from 'react'
import SarasTooltip from '../../../../library/notifications/SarasTooltip'

const DocGridStatView = (props) => {
    const { viewData } = props

    const renderDataValue = (row, rowValueKey) =>{
        var rowValue = row.rowValues[rowValueKey];

        return (
            <SarasTooltip title={rowValue.dataList.tooltip}>
                <div style={{ lineHeight: "1.3", display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{fontWeight:'bold', width: '120px', display:'inline-block'}}>{rowValue.dataList.label}</span>
                    <span>{rowValue.valF || rowValue.val}</span>
                </div>
            </SarasTooltip>
        )
    }

    const renderData = () =>{
        return(
            <div className="uiBox" style={{margin:'0px', height:"150px"}}>{
                viewData.RowValuesKeys.map((rowValueKey, index)=>(
                    <div key={index}>
                        {renderDataValue(viewData, rowValueKey)}
                    </div>
                ))
                }
            </div>
        )
    }

    return (
    <>
            {renderData()}
        </>
    )
}

export default DocGridStatView
